export default __webpack_public_path__ + "static/media/colgate_02.13fb75bd.png";